'use client'

import { createRedirectIntent } from '@/feature/navigation/services/navigation.intents'
import { twMerge } from '@/lib/classname/twMerge'
import { Link } from '@/ui/links/link/Link.client'
import { Picture } from '@/ui/media/picture/Picture.client'
import { generatePictureSource } from '@/ui/media/picture/Picture.service'
import { Skin } from '@/ui/skin/Skin'

export const DEFAULT_PHONE_CALLBACK_IMAGE_URL = '/media/image/phone-callback.png'

type NeedHelpBannerProps = UiComponentProps & {
  imageUrl?: string
  imageAlt: string
  title: React.ReactNode
  linkText: string
  href: string
  icon: React.ComponentProps<typeof Link>['iconLeft']
}

export function NeedHelpBanner({
  className,
  imageUrl = DEFAULT_PHONE_CALLBACK_IMAGE_URL,
  imageAlt,
  title,
  linkText,
  href,
  icon,
  id,
  'data-testid': dataTestId,
  'aria-label': ariaLabel,
}: NeedHelpBannerProps) {
  return (
    <Skin
      tint="body-alt"
      className={twMerge('flex items-center overflow-hidden rounded-sm', className)}
      id={id}
      data-testid={dataTestId ?? 'need-help-banner'}
      aria-label={ariaLabel}
    >
      <Picture
        image={generatePictureSource({
          mobileUrl: imageUrl,
          alt: imageAlt,
        })}
        className="size-10"
      />
      <div className="flex grow flex-col gap-2 p-2 tablet:flex-row tablet:items-center">
        <span className="text-lg">{title}</span>
        <div className="tablet:ml-auto">
          <Link
            href={href}
            variant="button-primary"
            size="lg"
            iconLeft={icon}
            intent={createRedirectIntent({ to: href })}
          >
            {linkText}
          </Link>
        </div>
      </div>
    </Skin>
  )
}
